import React from 'react';

interface SidebarProps {
  currentView: 'booking' | 'appointments';
  onNavigate: (view: 'booking' | 'appointments') => void;
}

const Sidebar: React.FC<SidebarProps> = ({ currentView, onNavigate }) => {
  return (
    <aside className="hidden md:flex w-64 bg-white shadow-lg border-l border-slate-200 flex-col h-screen fixed right-0 top-0 z-30 pt-20">
      {/* Navigation Menu */}
      <nav className="flex-1 p-6 space-y-2">
        <div className="mb-6">
          <h2 className="text-xs font-semibold text-slate-500 uppercase tracking-wider px-4 mb-3">תפריט ראשי</h2>
        </div>

        <button
          onClick={() => onNavigate('appointments')}
          className={`w-full flex items-center gap-4 px-5 py-4 rounded-xl transition-all duration-200 group ${
            currentView === 'appointments'
              ? 'bg-gradient-to-r from-teal-500 to-blue-600 text-white shadow-lg shadow-teal-200'
              : 'text-slate-700 hover:bg-slate-50 hover:shadow-md'
          }`}
        >
          <div className={`p-2 rounded-lg ${
            currentView === 'appointments' 
              ? 'bg-white/20' 
              : 'bg-slate-100 group-hover:bg-slate-200'
          }`}>
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
            </svg>
          </div>
          <span className="font-semibold text-base">התורים שלי</span>
        </button>

        <button
          onClick={() => onNavigate('booking')}
          className={`w-full flex items-center gap-4 px-5 py-4 rounded-xl transition-all duration-200 group ${
            currentView === 'booking'
              ? 'bg-gradient-to-r from-teal-500 to-blue-600 text-white shadow-lg shadow-teal-200'
              : 'text-slate-700 hover:bg-slate-50 hover:shadow-md'
          }`}
        >
          <div className={`p-2 rounded-lg ${
            currentView === 'booking' 
              ? 'bg-white/20' 
              : 'bg-slate-100 group-hover:bg-slate-200'
          }`}>
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
            </svg>
          </div>
          <span className="font-semibold text-base">תור חדש</span>
        </button>
      </nav>

      {/* Footer Info */}
      <div className="p-6 border-t border-slate-200 bg-slate-50">
        <div className="text-center">
          <p className="text-xs text-slate-500">מערכת ניהול תורים</p>
          <p className="text-xs text-slate-400 mt-1">v1.2</p>
        </div>
      </div>
    </aside>
  );
};

export default Sidebar;
